module.exports = __webpack_public_path__ + "img/empty-line-chart.368ea710.svg";